module.exports = __webpack_public_path__ + "9920dedffcf064c54633605ae6adb493.jpg";